import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents';
import AppNavbar from './Layout/AppNavbar.vue';
import AppFooter from './Layout/AppFooter.vue';
import swal from 'sweetalert2';
import axios from 'axios';
;
let ConfirmationSentViewModel = class ConfirmationSentViewModel extends Vue {
    constructor() {
        super();
    }
    get idpBaseUrl() {
        return process.env.VUE_APP_IDP_BASE_URL;
    }
    get idpUsername() {
        return process.env.VUE_IDM_ACCOUNT_USERNAME;
    }
    get idpPassword() {
        return process.env.VUE_IDM_ACCOUNT_PASSWORD;
    }
    get emailAddress() {
        return this.$route.query.emailAddress;
    }
    login() {
        this.$router.push("/login");
    }
    async resendConfirmation() {
        let userPost = { user: { username: this.emailAddress, realm: "PRIMARY" }, properties: [] };
        let encodedAuth = 'Basic ' + btoa(this.idpUsername + ':' + this.idpPassword);
        let axiosConfig = {
            headers: {
                'Authorization': encodedAuth,
                'Content-Type': 'application/json'
            }
        };
        try {
            await axios.post(this.idpBaseUrl + '/api/identity/recovery/v0.9/recover-password?type=email&notify=true', userPost, axiosConfig);
            await swal.fire({
                title: `Confirmation Sent`,
                text: `We have resent the confirmation email to ` + this.emailAddress,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info btn-fill'
            });
        }
        catch (error) {
            console.log('Failed to post recovery requests. ' + error);
        }
    }
    mounted() {
        console.log('Params: ' + this.$route.query.emailAddress);
    }
};
ConfirmationSentViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
            AppNavbar,
            AppFooter
        }
    })
], ConfirmationSentViewModel);
export default ConfirmationSentViewModel;
